import { pipe } from 'fp-ts/function';
import { filterMap } from 'fp-ts/Array';
import { option } from 'fp-ts';
import { DetailedUser, User, UserProfileResult } from '@mews-commander/data-access';

export const useIsUserProvisioned = (userProfile?: UserProfileResult | DetailedUser | User): boolean =>
    !!userProfile?.isScimProvisioned;

export const useProvisionedUserIds = (users?: Pick<UserProfileResult, 'isScimProvisioned' | 'userId'>[]): string[] => {
    if (!users?.length) {
        return [];
    }

    return pipe(
        users,
        filterMap((user) => (user.isScimProvisioned ? option.some(user.userId) : option.none))
    );
};
